import { FormModal } from '../../Form'

import {
  REQUEST_EDIT_PIPELINE_MODAL_FIELD_NAME_SWITCH_PIPELINE,
  REQUEST_EDIT_PIPELINE_MODAL_INITIAL_VALUES,
  REQUEST_EDIT_PIPELINE_MODAL_QA_NAME,
} from './RequestEditPipelineModal.constants'
import { isRequestEditPipelineModalYesNoOptionValueYes } from './RequestEditPipelineModal.utils'
import { RequestEditPipelineModalFields } from './RequestEditPipelineModalFields'

function RequestEditPipelineModal({
  categoryPayload,
  initialValues = REQUEST_EDIT_PIPELINE_MODAL_INITIAL_VALUES,
  onClose,
  onSubmit,
}) {
  function handleSubmit({ values }) {
    const isSwitchPipeline = isRequestEditPipelineModalYesNoOptionValueYes(
      values?.[REQUEST_EDIT_PIPELINE_MODAL_FIELD_NAME_SWITCH_PIPELINE]
    )

    const payload = isSwitchPipeline
      ? { ...categoryPayload, switch_pipeline: true }
      : categoryPayload

    return onSubmit?.({ isSwitchPipeline, payload })
  }

  return (
    <FormModal
      Fields={RequestEditPipelineModalFields}
      containerProps={{
        qaName: REQUEST_EDIT_PIPELINE_MODAL_QA_NAME,
      }}
      formTitle='Modal.RequestProfileEditPipelineModalTitleKey'
      initialValues={initialValues}
      onClose={onClose}
      onSubmit={handleSubmit}
    />
  )
}

export default RequestEditPipelineModal
